import { defineMessages, FormattedMessage } from 'react-intl';

export const messages = defineMessages({
  totalAmountPayable: {
    id: 'payment.financeCalculator.totalAmountPayable',
    defaultMessage: 'Total amount payable',
  },
  yourProvider: {
    id: 'payment.financeCalculator.yourProvider',
    defaultMessage: 'Your provider',
  },
  monthlyLoanTerm: {
    id: 'payment.financeCalculator.monthlyLoanTerm',
    defaultMessage: 'Monthly loan term',
  },
  yourMonthlyPayments: {
    id: 'payment.financeCalculator.yourMonthlyPayments',
    defaultMessage: 'Your monthly payments',
  },
  months: {
    id: 'payment.financeCalculator.months',
    defaultMessage: 'Months',
  },
  cembrapay: {
    id: 'payment.financeCalculator.cembrapay',
    defaultMessage: 'Cembrapay',
  },
  taeg: {
    id: 'payment.financeCalculator.taeg',
    defaultMessage: 'taeg',
  },
  totalPrice: {
    id: 'payment.financeCalculator.totalPrice',
    defaultMessage: 'total price',
  },
  creditplusBank: {
    id: 'payment.financeCalculator.creditplusBank',
    defaultMessage: 'Creditplus Bank',
  },
  netLoanAmount: {
    id: 'payment.financeCalculator.netLoanAmount',
    defaultMessage: 'Net loan amount',
  },
  creditPlusAdvantagesText: {
    id: 'financeCalculator.creditPlusAdvantagesText',
    defaultMessage:
      'Pay quick and simple in monthly installments with Creditplus Bank. Your advantages:',
  },
  easyOnlineApplicationProcess: {
    id: 'financeCalculator.easyOnlineApplicationProcess',
    defaultMessage: 'Easy online application process',
  },
  smoothOnlineIdentificationVideoIdent: {
    id: 'financeCalculator.smoothOnlineIdentificationVideoIdent',
    defaultMessage: 'Smooth online identification through VideoIdent',
  },
  zeroApr: {
    id: 'financeCalculator.zeroApr',
    defaultMessage: '0% APR',
  },
  noHiddenFees: {
    id: 'financeCalculator.noHiddenFees',
    defaultMessage: 'No hidden fees',
  },
  creditPlusCalculatorTips1: {
    id: 'financeCalculator.creditPlusCalculatorTips1',
    defaultMessage:
      'Net loan amount = total loan amount, 0,00% APR, 0,00 % interest rate p.a.. Creditworthiness assumed.',
  },

  creditPlusCalculatorTips2: {
    id: 'financeCalculator.creditPlusCalculatorTips2',
    defaultMessage:
      'The information represent 6a Abs. 4 PAngV. Credit brokering is done exclusively for Creditplus Bank AG, Augustenstraße 7, 70178 Stuttgart',
  },
});

export const AgosText = ({
  amount,
  maxAmount,
  minAmount,
  monthlyPayment,
  months,
  totalAmountPayable,
}: {
  amount: JSX.Element;
  maxAmount: JSX.Element;
  minAmount: JSX.Element;
  monthlyPayment: JSX.Element;
  months: number;
  totalAmountPayable: JSX.Element;
}) => (
  <FormattedMessage
    defaultMessage='Importo finanziabile da {minAmount} a {maxAmount} fino a 60 mesi. Prima rata a 30 giorni – Esempio: {amount} (importo totale del credito) in {months} rate da {monthlyPayment} - TAN fisso 0% TAEG 0%. Il TAEG rappresenta il costo totale del credito espresso in percentuale annua e in certi casi può essere diverso da zero esclusivamente per effetto di arrotondamento decimale. Tutti i costi azzerati - importo totale dovuto {totalAmountPayable}. Offerta valida fino al 31/12/2025. Informazioni precontrattuali al documento “Informazioni europee di base sul credito ai consumatori” (SECCI) nella pagina web dedicata unitamente a copia del testo contrattuale, al momento del caricamento della richiesta di finanziamento non impegnativa. Salvo approvazione Finanziaria. Messaggio pubblicitario. Breitling è un intermediario del credito non in esclusiva'
    id='financeCalculator.AgosText'
    values={{
      minAmount,
      maxAmount,
      amount,
      months,
      monthlyPayment,
      totalAmountPayable,
    }}
  />
);
